import { createAppRequest } from '@/services/request';

export interface OpenPlatformTokenResult {
  accessToken: string;
}

export interface MemberM2mTokenResult {
  accessToken: string;
  expiresAt?: number;
}

/** 当前组织开放平台 M2M Token：通知/权限管理等场景 */
export function getOpenPlatformToken() {
  return createAppRequest()<OpenPlatformTokenResult>('/bff/open-platform/token', {
    method: 'GET',
  });
}

/** 任意已登录成员：@zhiyue/task-management */
export function getTaskManagementToken() {
  return createAppRequest()<MemberM2mTokenResult>(
    '/bff/open-platform/task-management-token',
    { method: 'GET' },
  );
}

/** 任意已登录成员：@zhiyue/schedule */
export function getScheduleToken() {
  return createAppRequest()<MemberM2mTokenResult>('/bff/open-platform/schedule-token', {
    method: 'GET',
  });
}
